import { render, staticRenderFns } from "./cohort-selection.vue?vue&type=template&id=74ac2cd6&scoped=true&"
import script from "./cohort-selection.ts?vue&type=script&lang=ts&"
export * from "./cohort-selection.ts?vue&type=script&lang=ts&"
import style0 from "./cohort-selection.scss?vue&type=style&index=0&id=74ac2cd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ac2cd6",
  null
  
)

export default component.exports